import { Box, FormControlLabel } from '@mui/material';
import { useEffect, useState } from 'react';
import type { PartnerFacilitiesFilter } from '../../API/services/PartnerFacilityFilterService';
import CustomTypography from '@ui-components/Typography/CustomTypography';
import CustomCheckbox from '@ui-components/CheckBox/CustomCheckBox';

type Props = Readonly<{
  data: PartnerFacilitiesFilter | undefined;
  value?: number[];
  onChange?: (value: number[]) => void;
  userType?: string;
}>;

export function RoleFilterSelector({ data, value, onChange, userType }: Props) {
  console.log('here is the RoleFilterSelector value', value);
  const [selectedRoles, setSelectedRoles] = useState<number[]>([]);

  useEffect(() => {
    if (value) {
      setSelectedRoles(value);
    }
  }, [value]);

  const handleRoleIdSelection = (isChecked: boolean, roleId: number) => {
    setSelectedRoles((prev) => {
      const updated = isChecked
        ? [...prev, roleId]
        : prev.filter((id) => id !== roleId);
      onChange?.(updated); // ✅ pass latest value
      return updated;
    });
  };
  useEffect(() => {
    console.log('selectedRoles', selectedRoles);
  }, [selectedRoles]);

  const userRoleData =
    userType === 'facilityuser'
      ? data?.facilityUserRoleList
      : data?.opsStaffRoleList;

  return (
    <Box>
      {userRoleData?.map((role) => {
        return (
          <Box key={role.id} className="">
            <FormControlLabel
              control={
                <CustomCheckbox
                  id="partner-name-withCheckbox"
                  checked={selectedRoles.includes(role.id)}
                  onChange={(e) => {
                    handleRoleIdSelection(e.target.checked, role.id);
                  }}
                />
              }
              label={
                <CustomTypography
                  id="partner-name-withCheckbox"
                  variant="body2"
                >
                  {role.name}
                </CustomTypography>
              }
            />
          </Box>
        );
      })}
    </Box>
  );
}
